import { useState, useEffect, useCallback } from "react";

const PageHeroCarousel = ({ images, title, subtitle, altText, interval = 5000 }) => {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % images.length);
  }, [images.length]);

  useEffect(() => {
    const timer = setInterval(next, interval);
    return () => clearInterval(timer);
  }, [next, interval]);

  return (
    <div
      className="relative w-full h-48 sm:h-56 md:h-64 lg:h-72 overflow-hidden -m-4 lg:-m-6 mb-4 z-0 print:hidden"
      data-testid="page-hero-carousel"
    >
      {/* Background Images */}
      {images.map((img, idx) => (
        <div
          key={idx}
          className="absolute inset-0 transition-opacity duration-1000 ease-in-out"
          style={{ opacity: idx === current ? 1 : 0 }}
        >
          <img
            src={img.url}
            alt={img.alt || altText || title}
            className="w-full h-full object-cover"
            style={{ objectPosition: img.position || "center" }}
          />
        </div>
      ))}

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#2F6DB5]/70 via-[#2F6DB5]/50 to-transparent" />

      {/* Bottom fade */}
      <div className="absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-white to-transparent" />

      {/* Title Text */}
      <div className="absolute inset-0 flex items-center">
        <div className="px-6 sm:px-10 md:px-16 max-w-2xl">
          <h1
            className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1 drop-shadow-lg"
            style={{ textShadow: "2px 2px 4px rgba(0,0,0,0.3)" }}
          >
            {title}
          </h1>
          {subtitle && (
            <p
              className="text-sm sm:text-base text-white/90 drop-shadow-md"
              style={{ textShadow: "1px 1px 2px rgba(0,0,0,0.3)" }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Dots indicator */}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 z-20">
        {images.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-2 h-2 rounded-full transition-all ${
              idx === current ? "bg-white w-4" : "bg-white/50"
            }`}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default PageHeroCarousel;
